export default __webpack_public_path__ + "static/11-f4561539eb2e18b5034679529dd2a498.png";